import React from "react";
import { Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Close from "@material-ui/icons/Close";

const ImageViewer = ({ imageUrl, onClose, isPopupOpen }) => {
  return (
    <Dialog open={isPopupOpen} onClose={onClose} maxWidth="lg">
      <div style={{ padding: "20px", maxWidth: "500px" }}>
        <img src={imageUrl} alt="Image" style={{ width: "100%" }} />
      </div>
    </Dialog>
  );
};

export default ImageViewer;
